import { COMPARE } from "./data";
import { Section, Mark } from "./ui";

export const Compare = () => (
  <Section id="comparatif" over="COMPARATIF" title="ScreenView face à TeamViewer, AnyDesk et NinjaOne"
    lead="TeamViewer et AnyDesk excellent en prise en main ; NinjaOne en supervision. ScreenView réunit les deux dans un seul outil.">
    <p className="md:hidden text-xs text-slate-500 mb-2" data-testid="compare-scroll-hint">Faites défiler le tableau vers la droite →</p>
    <div className="overflow-x-auto rounded-2xl border border-slate-800" data-testid="compare-table">
      <table className="w-full min-w-[640px] text-sm">
        <thead>
          <tr className="bg-slate-900/80">
            <th className="sticky left-0 z-10 bg-slate-900 text-left font-medium text-slate-400 px-4 md:px-5 py-4 w-[150px] md:w-auto">Fonctionnalité</th>
            {COMPARE.cols.map((c, i) => (
              <th key={c} className={`px-4 py-4 font-semibold w-[13%] ${i === 0 ? "text-sky-300 bg-sky-500/10" : "text-slate-200"}`}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {COMPARE.rows.map(([label, ...vals]) => (
            <tr key={label} className="border-t border-slate-800/80">
              <td className="sticky left-0 z-10 bg-[#090D16] px-4 md:px-5 py-3.5 text-slate-300 text-xs md:text-sm w-[150px] md:w-auto">{label}</td>
              {vals.map((v, i) => <td key={i} className={`px-4 py-3.5 text-center ${i === 0 ? "bg-sky-500/5" : ""}`}><Mark v={v} /></td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="text-xs text-slate-500 mt-4 max-w-3xl" data-testid="compare-note">
      « partiel » : fonction limitée, disponible selon l'offre ou via un module payant en option. Comparatif établi d'après les informations publiques des éditeurs en 2026 ; leurs offres évoluent, vérifiez-les auprès d'eux. Marques citées appartenant à leurs propriétaires respectifs.
    </p>
  </Section>
);
